import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import api from "../api/axios";

export default function SertifikatForm() {
  const { webinarId, idPeserta, namaPeserta, noHp } = useParams();
  const [webinarImage, setWebinarImage] = useState(null);
  const [loadingImage, setLoadingImage] = useState(true);
  const [errorImage, setErrorImage] = useState(null);

  const tahun = new Date().getFullYear();
  const nomorSertifikat = `CONEXSEE/WEB${webinarId}/${tahun}/${String(idPeserta).padStart(5, '0')}`;

  useEffect(() => {
    const fetchWebinarImage = async () => {
      try {
        const response = await api.get(`/api/webinars/${webinarId}`);
        if (response.data && response.data.image) {
          setWebinarImage(`data:image/png;base64,${response.data.image}`);
        } else {
          setErrorImage("Gambar tidak ditemukan");
        }
      } catch (err) {
        console.error("Error fetching webinar image:", err);
        setErrorImage("Gagal memuat gambar webinar.");
      } finally {
        setLoadingImage(false);
      }
    };

    if (webinarId) {
      fetchWebinarImage();
    } else {
      setLoadingImage(false);
    }
  }, [webinarId]);

  const downloadAsImage = () => {
    const element = document.getElementById("certificate");
    html2canvas(element).then((canvas) => {
      const link = document.createElement("a");
      link.download = `sertifikat-${namaPeserta}.png`;
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  return (
    <div className="min-h-screen p-6 bg-gray-100 font-sans">
      
      <link href="https://fonts.googleapis.com/css2?family=Pinyon+Script&family=Raleway:wght@400;700&display=swap" rel="stylesheet">
      </link>

      <div className="mb-4 space-y-3 max-w-md text-center mx-auto">
        <h1 className="text-2xl font-bold mb-4">Sertifikat Webinar</h1>          
      </div>

      {loadingImage ? (
        <div className="text-center text-lg font-medium text-gray-600 mt-10">
          Memuat sertifikat...
        </div>
      ) : errorImage ? (
        <div className="text-center text-red-500">{errorImage}</div>
      ) : (
        <>
        <div className="text-center my-4">
            <button
              onClick={downloadAsImage}
              className="btn btn-success text-white px-4 py-2 rounded hover:bg-green-700"
            >
              Download Sertifikat
            </button>
        </div>
        <div className="mt-6 overflow-auto">
          <div
            id="certificate"
            className="relative bg-white border mx-auto"
            style={{
              width: "1122px",
              height: "793px",
              backgroundImage: `url(${webinarImage})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              paddingTop: "236px",
              fontFamily: "'Raleway', sans-serif"
            }}
          >
            {/* Nomor sertifikat */}
            <div
              style={{
                marginLeft: "50px",
                marginBottom: "75px",
                fontSize: "14px",
                color: "#48075aff",
                fontFamily: "'Raleway', sans-serif"
              }}
            >
              <b>{nomorSertifikat}</b>
            </div>

            {/* Nama peserta */}
            <div
              style={{
                fontSize: namaPeserta.length > 24 ? "37px" : "57px",
                color: "#3d0963ff",
                marginLeft: "250px",
                fontFamily: "'Pinyon Script', cursive"
              }}
            >
              <b>{namaPeserta}</b>
            </div>
          </div>

        </div>
        </>
      )}
    </div>
  );
}
